var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWondering(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500.88px",
    height: "418.62px",
    viewBox: "0 0 500.88 418.62",
    enableBackground: "new 0 0 500.88 418.62",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDDFE3",
    d: "M59.82,356.01c67.87,72.87,139.76,57.67,236.59,48.68s158.72-15.97,189.67-133.77S407.43,3.36,268.46,8.39 C102.75,14.38-85.92,199.51,59.82,356.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#868B90",
    d: "M105.78,312.45c49.58,53.23,102.1,42.13,172.83,35.57c70.74-6.56,115.95-11.67,138.56-97.72 S359.71,54.84,258.19,58.51C137.14,62.88-0.69,198.13,105.78,312.45z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 244.3346,
    cy: 206.0526,
    r: 236.5524,
    gradientTransform: "matrix(0.9745 -0.2246 0.2041 0.8858 -35.8208 78.4118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A9AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAEB2",
      stopOpacity: 0.0296
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M105.78,312.45c49.58,53.23,102.1,42.13,172.83,35.57c70.74-6.56,115.95-11.67,138.56-97.72 S359.71,54.84,258.19,58.51C137.14,62.88-0.69,198.13,105.78,312.45z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 244.3346,
    cy: 206.0526,
    r: 170.9787,
    gradientTransform: "matrix(1 -1.401890e-03 1.143257e-03 0.8155 -0.2346 38.3571)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C8CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6534,
    style: {
      stopColor: "#C2C6CA",
      stopOpacity: 0.3466
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9682,
    style: {
      stopColor: "#BAC0C3",
      stopOpacity: 0.0318
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9BFC2",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M105.78,312.45c49.58,53.23,102.1,42.13,172.83,35.57c70.74-6.56,115.95-11.67,138.56-97.72 S359.71,54.84,258.19,58.51C137.14,62.88-0.69,198.13,105.78,312.45z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 244.3346,
    cy: 206.0526,
    r: 132.3206,
    gradientTransform: "matrix(1 -1.401890e-03 1.143257e-03 0.8155 -0.2346 38.3571)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#DDE2E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M105.78,312.45c49.58,53.23,102.1,42.13,172.83,35.57c70.74-6.56,115.95-11.67,138.56-97.72 S359.71,54.84,258.19,58.51C137.14,62.88-0.69,198.13,105.78,312.45z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2829 -0.9591 0.9591 0.2829 -44.4952 294.5846)",
    fill: "#181818",
    cx: 174.77,
    cy: 177.05,
    rx: 52.74,
    ry: 38.39
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2829 -0.9591 0.9591 0.2829 -44.6402 291.303)",
    fill: "#1B2226",
    cx: 172.5,
    cy: 175.51,
    rx: 40.75,
    ry: 29.59
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2829 -0.9591 0.9591 0.2829 -40.9003 287.2816)",
    fill: "#2A373F",
    cx: 171.69,
    cy: 171,
    rx: 33.6,
    ry: 26.05
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2123 -0.9772 0.9772 0.2123 98.2345 463.8618)",
    fill: "#181818",
    cx: 336.86,
    cy: 171,
    rx: 49.52,
    ry: 36.05
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2123 -0.9772 0.9772 0.2123 98.4118 460.1386)",
    fill: "#1B2226",
    cx: 334.63,
    cy: 169.02,
    rx: 39.49,
    ry: 26.9
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2829 -0.9591 0.9591 0.2829 80.4159 435.3365)",
    fill: "#2A373F",
    cx: 331.36,
    cy: 163.89,
    rx: 29.6,
    ry: 21.45
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9927 -0.1206 0.1206 0.9927 -18.1941 20.7849)",
    fill: "#50F61E",
    cx: 162.56,
    cy: 160.65,
    rx: 12.21,
    ry: 11.06
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9927 -0.1206 0.1206 0.9927 -21.7149 23.7554)",
    fill: "#50F61E",
    cx: 185.33,
    cy: 191.21,
    rx: 7.81,
    ry: 6.61
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9927 -0.1206 0.1206 0.9927 -16.3711 39.8568)",
    fill: "#50F61E",
    cx: 320.98,
    cy: 155.13,
    rx: 9.68,
    ry: 8.76
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9927 -0.1206 0.1206 0.9927 -19.8506 42.3788)",
    fill: "#50F61E",
    cx: 340.07,
    cy: 185.13,
    rx: 5.54,
    ry: 4.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.1551,
    y1: 247.216,
    x2: 258.1042,
    y2: 214.8001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404749"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    style: {
      stopColor: "#313537"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181818"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M239.68,220h35.71c2.57,0,4.55,2.28,4.15,4.82c-1.2,7.69-5.64,21.9-22.01,21.9 s-20.81-14.21-22.01-21.9C235.13,222.29,237.12,220,239.68,220z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWondering);
export default __webpack_public_path__ + "static/media/wondering.d9412d5abab483c6e693ead04e2da4f6.svg";
export { ForwardRef as ReactComponent };